import { CallResult } from '../callExternalApi';
import { getSelectedAccountIds, getSelectedAccountIdsForUrl, getAccountScope } from '../../store/User';

export const getAdviseAccountIds = () => getSelectedAccountIdsForUrl();
export const getAdviseAccountId = () => getSelectedAccountIds()?.[0];
export const getAdviseAccountName = () => getAccountScope()?.[0]?.name;

export const withAdviseAccountIds = async <T>(
  records: string,
  call: (accountIds: string[]) => Promise<CallResult<T>>
): Promise<CallResult<T>> => {
  const accountIds = getAdviseAccountIds();
  if (!accountIds?.length) return { data: null, error: { message: `Must select an account to fetch ${records}` } };
  return call(accountIds);
};
